import { Injectable, Signal } from '@angular/core';
import { BaseFacade, Filter, Pagination } from '@iot-platform/models/common';
import { DeviceVariable } from '@iot-platform/models/i4b';
import { Store } from '@ngrx/store';
import { DeviceVariablesActions } from '../actions';
import { DeviceVariablesSelectors } from '../selectors/device-variables.selectors';
import { noop } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceVariablesFacade extends BaseFacade<DeviceVariable, Pagination, Filter> {
  deviceVariables: Signal<DeviceVariable[]> = this.store.selectSignal(this.selector.selectAll);

  constructor(
    protected store: Store,
    protected selector: DeviceVariablesSelectors
  ) {
    super(store, selector);
  }

  getAll() {
    noop();
  }

  setFilters(): void {
    noop();
  }

  loadDeviceVariables(deviceId: string) {
    this.store.dispatch(DeviceVariablesActions.loadDeviceVariables({ deviceId }));
  }

  resetDeviceVariablesLastValues(variablesIds: string[]) {
    this.store.dispatch(DeviceVariablesActions.resetDeviceVariablesLastValue({ variablesIds }));
  }

  deleteDeviceVariables(variablesIds: string[]) {
    this.store.dispatch(DeviceVariablesActions.deleteDeviceVariables({ variablesIds }));
  }
}
